export default "__VITE_ASSET__CZIAC7v1__"